module.exports = __webpack_public_path__ + "static/img/homepageLogo.3b466d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/homepageLogo.png
// module id = zN/D
// module chunks = 55